import React, { useEffect } from 'react'
import AOS from "aos";
import AboutApp from '../HomeMain/AboutApp/Main'
import Design from '../HomeMain/Design/Main'
import Testimonial from '../HomeMain/Testimonial/Main'
import Pricing from '../HomeMain/Pricing/Main'
import Faq from '../HomeMain/Faq/Main'
import Interface from '../HomeMain/Interface/Main'
import Download from '../HomeMain/Download/Main'
import Story from '../HomeMain/Story/Main'
import Trusted from '../HomeMain/Trusted/Main'
import Banner from '../Menhomegredient/Banner';
import Features from '../Menhomegredient/Features';
import Workstwo from '../HomeMain/Work/Main'

const Main = ({ setnavbar, setfooter }) => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  useEffect(() => {
    setfooter({ f3: true })
    setnavbar({ n5: true })
    localStorage.setItem("navbar", "homegredient")

  }, [])

  return (
    <>
      <Banner />
      <Features />
      <AboutApp />
      <Design gredient={true} />
      <Workstwo />
      <Testimonial />
      <Pricing gredient={true} />
      <Faq gredient={true} />
      <Interface />
      <Download />
      <Story />
      <Trusted />
    </>
  )
}

export default Main